export const productGroupConstants = {
    // list
    GET_PRODUCT_GROUPS: "GET_PRODUCT_GROUPS",
    GET_PRODUCT_GROUPS_SUCCESS: "GET_PRODUCT_GROUPS_SUCCESS",
    GET_PRODUCT_GROUPS_FAILURE: "GET_PRODUCT_GROUPS_FAILURE",

    // create
    CREATE_PRODUCT_GROUP: "CREATE_PRODUCT_GROUP",
    CREATE_PRODUCT_GROUP_SUCCESS: "CREATE_PRODUCT_GROUP_SUCCESS",
    CREATE_PRODUCT_GROUP_FAILURE: "CREATE_PRODUCT_GROUP_FAILURE",

    // update
    UPDATE_PRODUCT_GROUP: "UPDATE_PRODUCT_GROUP",
    UPDATE_PRODUCT_GROUP_SUCCESS: "UPDATE_PRODUCT_GROUP_SUCCESS",
    UPDATE_PRODUCT_GROUP_FAILURE: "UPDATE_PRODUCT_GROUP_FAILURE",

    // activate / inactivate
    CHANGE_PRODUCT_GROUP_STATUS: "CHANGE_PRODUCT_GROUP_STATUS",
    CHANGE_PRODUCT_GROUP_STATUS_SUCCESS: "CHANGE_PRODUCT_GROUP_STATUS_SUCCESS",
    CHANGE_PRODUCT_GROUP_STATUS_FAILURE: "CHANGE_PRODUCT_GROUP_STATUS_FAILURE",

    // delete (hard)
    DELETE_PRODUCT_GROUP: "DELETE_PRODUCT_GROUP",
    DELETE_PRODUCT_GROUP_SUCCESS: "DELETE_PRODUCT_GROUP_SUCCESS",
    DELETE_PRODUCT_GROUP_FAILURE: "DELETE_PRODUCT_GROUP_FAILURE",

    // assign multiple products to a sub group
    ASSIGN_PRODUCTS_TO_SUBGROUP: "ASSIGN_PRODUCTS_TO_SUBGROUP",
    ASSIGN_PRODUCTS_TO_SUBGROUP_SUCCESS: "ASSIGN_PRODUCTS_TO_SUBGROUP_SUCCESS",
    ASSIGN_PRODUCTS_TO_SUBGROUP_FAILURE: "ASSIGN_PRODUCTS_TO_SUBGROUP_FAILURE",

    // active groups dropdown (for product add/edit mapping)
    GET_PRODUCT_GROUP_DROPDOWN: "GET_PRODUCT_GROUP_DROPDOWN",
    GET_PRODUCT_GROUP_DROPDOWN_SUCCESS: "GET_PRODUCT_GROUP_DROPDOWN_SUCCESS",
    GET_PRODUCT_GROUP_DROPDOWN_FAILURE: "GET_PRODUCT_GROUP_DROPDOWN_FAILURE",

    CLEAR_PRODUCT_GROUP_MSG: "CLEAR_PRODUCT_GROUP_MSG"
}
